export const Roles = {
  SUPER_ADMIN: 1,
  ADMIN: 2,
  MANAGER: 3,
  SECURITY: 4,
  CSR: 5,
  PROD_SUPERVISOR: 6,
  PRODUCTION: 7,
  TRAINING: 8,
  CLIENT_MANAGER: 9,
  DEVELOPER: 11,
  CLIENT_REPRESENTATIVE: 13,
}
